import { Button } from "../../components/forms";
import { GoPlus } from "react-icons/go";
import { ListPicker } from "../../components/generic/ListPicker";
import { usePickerhook } from "../../hooks/usePickerhook";
import { SearchBar } from "../../components/generic/SearchBar";
import { useState } from "react";
import { UserItem } from "../../components/users/UserItem";
import { RoleItem } from "../../components/roles/RolesItem";
import AddRoleModal from "../../components/users/AddRole";
import Switch from "react-switch";
import { devFolder } from "../../constant/import";

const DeveloperMode = () => {
  
  
  const [toggledevmode, settoggledevmode] = useState(false);

   

  return (
    <div className="w-full pr-20  flex  ">
 
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium  flex justify-center items-center text-sm mb-2 text-[18px] bg-white">
            Developer mode  <Switch
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor="#EAECF5"
                  onColor="#CB0E5F"
                  className="m-4"
                  onChange={() => {
                    settoggledevmode(!toggledevmode);
                  }}
                  checked={toggledevmode}
                />
          </p>

        
        </div>
     
        <hr />
{toggledevmode&&
      <div className="p-4  mt-4 border border-gray-300 rounded-[10px] ">

<p className="bold ">Custom Module/Plugin</p>
<img src={devFolder} />
      </div>}
      </div>
    </div>
  );
};
export { DeveloperMode };
